var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c(
        "div",
        { staticClass: "pl-20 pr-20 pb-10 bg-white" },
        [
          _c(
            "el-button",
            {
              staticClass: "mb-20 mt-20",
              attrs: { type: "success" },
              on: {
                click: function ($event) {
                  return _vm.save_plan.push({
                    img_url: "",
                    product_name: "",
                    product_id: "",
                    cost_price: "",
                    market_price: "",
                  })
                },
              },
            },
            [_vm._v("添加仓口")]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "auto" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.save_plan, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "仓口", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.$index + 1) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "选择商品" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex align-center" },
                              [
                                scope.row.img_url
                                  ? _c("el-avatar", {
                                      attrs: {
                                        shape: "square",
                                        size: 50,
                                        src: scope.row.img_url,
                                        fit: "fill",
                                        icon: "el-icon-picture-outline",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "pl-10 pr-10 flex1" },
                                  [_vm._v(_vm._s(scope.row.product_name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.selCang = scope.row
                                        _vm.selGoodsDialog = true
                                      },
                                    },
                                  },
                                  [_vm._v("选择商品")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "成本价", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-input",
                              {
                                attrs: { placeholder: "成本价", disabled: "" },
                                model: {
                                  value: scope.row.cost_price,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "cost_price", $$v)
                                  },
                                  expression: "scope.row.cost_price",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "零售价", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-input",
                              {
                                attrs: { placeholder: "零售价" },
                                model: {
                                  value: scope.row.market_price,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "market_price", $$v)
                                  },
                                  expression: "scope.row.market_price",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  round: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.save_plan.splice(scope.$index, 1)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "mt-30" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("立即提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.selGoodsDialog,
            "body-style": "padding: 0",
          },
          on: {
            "update:visible": function ($event) {
              _vm.selGoodsDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "ptd-5",
              attrs: { data: _vm.goodsList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "图片", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-avatar", {
                          attrs: {
                            shape: "square",
                            size: 50,
                            src: scope.row.img_url,
                            fit: "fill",
                            icon: "el-icon-picture-outline",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品标题", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.product_name) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "副标题" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.product_title) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "价格" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v("成本价：" + _vm._s(scope.row.cost_price)),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("零售价：" + _vm._s(scope.row.market_price)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary", round: "" },
                            on: {
                              click: function ($event) {
                                return _vm.selGoods(scope.row)
                              },
                            },
                          },
                          [_vm._v("选择此商品")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-10 flex justify-center" },
            [
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listQuery.page_num > 0,
                    expression: "listQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.listQuery.start,
                  limit: _vm.listQuery.limit,
                  "page-count": _vm.listQuery.page_num,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "start", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "limit", $event)
                  },
                  pagination: _vm.getGoods,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }